import { NoNav } from '@/layouts'
import { requiresAuthNoAlert } from '@/lib/auth'

export default [
  {
    path: '/wizard',
    component: NoNav,
    beforeEnter: requiresAuthNoAlert,
    children: [
      {
        name: 'wizard',
        path: '',
        component: () => import('@/views/Wizard/StepA'),
      },
      {
        name: 'wizardB',
        path: 'stepB',
        component: () => import('@/views/Wizard/StepB'),
      },
      {
        name: 'wizardC',
        path: 'stepC',
        component: () => import('@/views/Wizard/StepC'),
      },
      {
        name: 'wizardD',
        path: 'stepD',
        component: () => import('@/views/Wizard/StepD'),
      },
      {
        name: 'wizardE',
        path: 'stepE',
        component: () => import('@/views/Wizard/StepE'),
      },
    ],
  },
  {
    name: 'wizard/confirm',
    path: '/next-steps',
    component: () => import('@/views/Wizard/Confirmation'),
    beforeEnter: requiresAuthNoAlert,
  },
  { 
    path: '/alerts',
    component: NoNav,
    children: [
      {
        name: 'alerts/accept',
        path: 'accept',
        component: () => import('@/views/Alerts/Accept'),
      },
      {
        name: 'alerts/payment_method',
        path: 'payment_method',
        component:  () => import('@/views/Alerts/PaymentMethod'),
      },
      {
        name: 'alerts/needs_setup',
        path: 'activate',
        component: () => import('@/views/Wizard/StepA'),
      },
    ],
  },
]